import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import FlexContainer from '@components/FlexContainer/FlexContainer';

import './Separator.scss';

const Separator = ({ isBlack }) => (
  <div className={cx('separator', { 'separator--black': isBlack })}>
    <div className="separator__margin" />
    <FlexContainer className="separator__flex-container">
      <div className="separator__container">
        <div className="separator__item" />
        <div className="separator__item" />
        <div className="separator__item" />
      </div>
    </FlexContainer>
    <div className="separator__margin" />
  </div>
);

Separator.propTypes = {
  isBlack: PropTypes.bool,
};

Separator.defaultProps = {
  isBlack: false,
};

export default Separator;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/Separator/Separator.js